module.exports = "/images/copy-link.svg?764b1d7a827de9b86092dcd615b4d490";